import { HTMLAttributes } from 'react'

import SVGIcon from '@/components/base/SVGIcon'

import { useStore } from '@/contexts/store'

type ChatbotProps = HTMLAttributes<HTMLDivElement>

const Chatbot = (props: ChatbotProps) => {
  const { strings } = useStore()
  return strings?.footer?.contact_link?.url ? (
    <div
      className="lg:right-4rem] fixed bottom-sm right-[2rem] z-chatbot md:bottom-xl xl:right-[8rem]"
      {...props}
    >
      <a
        className="flex h-[6rem] w-[6rem] items-center justify-center rounded-xxs bg-[#111111] shadow-3xl"
        href={strings?.footer?.contact_link?.url}
      >
        <SVGIcon symbol="mail" className="h-[1.9rem] w-[2.1rem] fill-white" />
      </a>
    </div>
  ) : null
}

export default Chatbot
